import palette from "../../utilities/palette";

// Using the styles and themes props for React: https://react-select.com/styles#styles
export const asyncSelectStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      width: "550px",
      fontSize: "18px",
    }),
    menu: (baseStyles, state) => ({
      ...baseStyles,
      width: "550px",
    }),
  };


export const getSelectStyles = (isArchitectureTypeMatch, variant = "default", isError = false) => {


  const toBeReturnedStyle = {
    control: (baseStyles, state) => {
      
      return {
      ...baseStyles,
      cursor: 'pointer',
      width: "550px",
      fontSize: "18px",
      borderColor: (() => {
        if (isError) return palette.stepper.error;
        if (variant === "header") return palette.header.main;
        if (variant === "body") return "white";
        return baseStyles.borderColor;
      })(),
      // Extracted backgroundColor logic
      backgroundColor: (() => {
        if (variant === "header") return palette.header.main;
        if (variant === "body") return "white";
        return baseStyles.backgroundColor;
      })(),
       
      ...(state.isDisabled ? {
        backgroundColor: 'rgba(239, 239, 239, 0.3)',
        borderColor: 'rgb(219, 219, 219)',
      } : {}),

      ":hover": {
        backgroundColor: (() => {
          if (variant === "header") return "white";
          if (variant === "body") return "white"
          return palette.header.main;
        })(),
        borderColor: (() => {
          if (variant === "header") return palette.main;
          return palette.main;
        })(),
      },
    }},
  
  
    container: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: 'rgba(255, 255, 255, 1)',
      ...(state.isDisabled ? {
        backgroundColor: 'rgba(239, 239, 239, 0.3)',
        borderColor: 'rgb(219, 219, 219)',
      } : {}),

      ...(state.isFocused ? {
        borderColor: palette.primary.main,
      } : {}),
    }),
  
    
    menu: (baseStyles, state) => ({
      ...baseStyles,
      width: "550px",
      cursor: 'pointer',
    }),

    option: (baseStyles, state) => ({
      ...baseStyles,
      cursor: 'pointer',
    }),

    dropdownIndicator: (baseStyles, state) => ({
      ...baseStyles,
      // cursor: 'pointer',
      color: palette.main,
      // ":hover": {
      //   color: palette.main,
      // }
    }),

    indicatorSeparator: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: palette.main,
      // ":hover": {
      //   backgroundColor: palette.main,
      // }
    }),

    clearIndicator: (baseStyles, state) => ({
      ...baseStyles,
      color: palette.main,
      // ":hover": {
      //   color: palette.main,
      // },
      cursor: 'pointer'
    }),

    placeholder: (baseStyles, state) => ({
      ...baseStyles,
      color: palette.main,
    }),

    loadingIndicator: (baseStyles, state) => ({
      ...baseStyles,
      color: palette.main,
    }),

    // singleValue: (baseStyles, state) => ({
    //   ...baseStyles,
    //   color: palette.main,
    // }),

    // multiValueLabel: (baseStyles, state) => ({
    //   ...baseStyles,
    //   color: palette.main, // Text color of the tag
    // }),

    // multiValueRemove: (baseStyles, state) => ({
    //   ...baseStyles,
    //   color: palette.main, // Color of the remove icon
    //   cursor: 'pointer',
    //   ':hover': {
    //     backgroundColor: palette.main,
    //     color: 'white',
    //   },
    // }),
    
  
  
  }


  return toBeReturnedStyle;
};

export const getSelectStylesWithError = (isArchitectureTypeMatch) => ({
  control: (baseStyles, state) => ({
    ...baseStyles,
    width: "550px",
    fontSize: "18px",
    border: `1px solid ${palette.stepper.error}`,
    ...(isArchitectureTypeMatch ? {} : {
      backgroundColor: !isArchitectureTypeMatch ? "darkgrey" : "",
      color: !isArchitectureTypeMatch ? "darkgrey" : ""
    }),
  }),
  menu: (baseStyles, state) => ({
    ...baseStyles,
    width: "550px",
  }),
});

export const preEditSelectStyles = {

    control: (baseStyles, state) => ({
      ...baseStyles,
      width: "550px",
      fontSize: "18px",
    }),
    menu: (baseStyles, state) => ({
      ...baseStyles,
      width: "550px",
    }),
  };
  
  
  
  export const asyncSelectStylesWithError = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      width: "550px",
      fontSize: "18px",
      border: `1px solid ${palette.stepper.error}`,
    }),
    menu: (baseStyles, state) => ({
      ...baseStyles,
      width: "550px",
    }),
  };

  
  
  export const asyncSelectTheme = (theme) => ({
    ...theme,
    borderRadius: 0,
    colors: {
      ...theme.colors,
      primary: palette.primary.main, // color of the selected border
      primary75: "#bbe2ee", // color of the option hover background
      primary50: "#c9ebf6",
      primary25: "#d8f5fe",
    },
  });
